export { default } from "./EventList";
